( function( $ ) {
	'use strict';

	$( function() {
		const $item         = $( '.js-tab-group-item' );
		const $trigger      = $( '.js-tab-group-trigger' );
		const $content 		= $( '.js-tab-group-content' );
		const $body         = $( '.js-tab-group-body' );
		const activeClass   = 'is-active';

		$trigger.on( 'click', function() {
			const isActive 	= $( this ).closest( $item ).hasClass( activeClass );
			const id 		= $( this ).attr( 'id' );

			if ( isActive ) return;

			// remove active class from all other items
			$item.each( function() {
				if ( $( this ).hasClass( activeClass ) ) {
					$( this ).removeClass( activeClass );
					$( this ).find( $trigger ).attr( 'aria-expanded', false );
				}
			} );

			// if the current item is not active, make it active
			if ( ! isActive ) {
                $( this ).closest( $item ).addClass( activeClass );
                $( this ).attr( 'aria-expanded', true );
			}

			// remove active class from all $content
			$content.each( function() {
				if ( $( this ).hasClass( activeClass ) ) {
					$( this ).removeClass( activeClass );
				}
			} );

			// add active class to $content with the matching aria attribute
			$content.each( function() {
				const labelledby = $( this ).attr( 'aria-labelledby' );

				if ( labelledby === id ) {
					$( this ).addClass( activeClass );
				}
			} );

			// remove active class from all $body
			$body.each( function() {
				if ( $( this ).hasClass( activeClass ) ) {
					$( this ).removeClass( activeClass );
				}
			} );

			// add active class to $body with the matching aria attribute
			$body.each( function() {
				const labelledby = $( this ).attr( 'aria-labelledby' );

				if( labelledby == id ) {
					$( this ).addClass( activeClass );
				}
			} );
		} );
	} );
} )( jQuery );
